import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from "react-hook-form";
import Box from '@mui/material/Box';
import MuiAlert from "@mui/material/Alert/Alert";
import CustomButton from "../_shared/CustomButton";
import Loader from "../_icons/Loader";
import SideBar from '../_shared/SideBar';
import StylesTextField from "../../commons/_muiOverride/StylesTextField";
import TextField from "@mui/material/TextField/TextField";
import TitleContainer from "../_shared/TitleContainer";
import styledSC from "styled-components";
import {styled} from "@mui/material";
import JwtInterceptor from "../_shared/JwtInterceptors";

const API_URL = process.env.REACT_APP_API_URL;

const Form = styledSC.form`
  width: 500px;
  margin-top: 25px;
  text-align: left;
`;

const Label = styledSC.label`
  display: block;
`;

const Input = styled(TextField)`
  ${StylesTextField}
`;

const Alert = React.forwardRef(function Alert(props, ref,) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AlertError = React.forwardRef(function Alert(props, ref,) {
  return <MuiAlert severity="error" ref={ref} variant="filled" {...props} />;
});

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
      >
        {value === index && (
            <Box sx={{ p: 3 }}>
              {children}
            </Box>
        )}
      </div>
  );
};

const SccdvPage = () => {
  const { t } = useTranslation();
  const { control, handleSubmit, formState: { errors } } = useForm();
  const [loader, setLoader] = useState(false);
  const [sendSuccess, setSendSuccess] = useState(false);
  const [sendError, setSendError] = useState(false);
  const [sendErrorText, setSendErrorText] = useState(t('errGeneral'));

  const onSubmit = async (data) => {
    if (!loader) {
      setLoader(true);
      setSendError(false);

      JwtInterceptor
          .post(`${API_URL}File/convert-xlsx`, data, {headers: {'Content-Type': 'multipart/form-data'}, responseType: 'blob'})
          .then((result) => {
            const href = URL.createObjectURL(result.data);
            const link = document.createElement('a');

            setSendSuccess(true);
            setLoader(false);

            link.href = href;
            link.setAttribute('download', 'Convert-export.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          })
          .catch(function (error) {
            // console.log(error);
            setSendErrorText(t('error'));
            setSendError(true);
            setLoader(false);
          });
    }
  };

  return (
      <div className='page-wrapper'>
        <SideBar filters={false} />
        <TitleContainer text={t('sccdv')} />
        <TabPanel>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Label>
            <Controller
                control={control}
                name="file"
                rules={{ required: "Recipe picture is required" }}
                render={({ field: { value, onChange, ...field } }) => {
                  return (
                      <Input
                          {...field}
                          value={value?.fileName}
                          onChange={(event) => {
                            onChange(event.target.files[0]);
                          }}
                          type="file"
                          id="file"
                      />
                  );
                }}
            />
          </Label>

          {sendError && <AlertError severity="error" sx={{ width: '468px' }}>{sendErrorText}</AlertError>}
          {sendSuccess && <Alert severity="success" sx={{ width: '468px' }}>{t('convertFileSuccess')}</Alert>}

          <CustomButton type="submit" text={t('convertFile')} icon={loader ? <Loader/> : ''} />
        </Form>
        </TabPanel>
      </div>
  );
}

export default SccdvPage;